import React, {
  useEffect,
  useState,
  Fragment,
  useContext,
  useRef,
  useCallback,
} from "react";
import LoadingContext from "../contexts/loading-context";
import UserContext from "../contexts/user-context";
import { getMyNotifications, getMoreSubscriptions } from "../api/userApi";
import Moment from "moment";
import { getSiteName } from "../api/siteApi";

export default function MyNotifications(props) {
  const { handleUserSignOut } = useContext(UserContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext);

  const [notifications, setNotifications] = useState([]);
  const [refreshing, setRefreshing] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    getNoti();
    return () => {};
  }, []);

  function getNoti() {
    getMyNotifications()
      .then((res) => {
        setIsLoading(false);

        setRefreshing(false);
        setNotifications(res.data.data);
      })
      .catch((e) => {
        setRefreshing(false);
        setIsLoading(false);

        console.error(e);
      });
  }

  async function loadMoreNoti() {
    if (!isLoading) {
      setIsLoading(true);
      console.log("\n....loading more");
      await getMoreSubscriptions({ currentLength: notifications.length })
        .then((res) => {
          setIsLoading(false);
          if (res && res.data.success) {
            console.log("....loaded\n");
            setNotifications([...notifications, ...res.data.data]);
          }
        })
        .catch((e) => {
          setIsLoading(false);
        });
    }
  }
  return (
    <div className="row justify-content-center">
      <div className="col-md-10">
        <h3>Your notifications</h3>
        <div
          className="accordion"
          id="accordionExample"
          style={{ height: "80vh", overflowY: "auto" }}
        >
          {notifications.map((n, i) => {
            return <Notification n={n} i={i} />;
          })}
          <button className="btn btn-success" onClick={loadMoreNoti}>
            {" "}
            Load more
          </button>
        </div>
      </div>
    </div>
  );
}

function Notification(props) {
  const { n, i } = props;
  const [siteName, setSiteName] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    if (n) {
      const isPriority = n.site.includes("-priority");
      getSiteName(isPriority ? n.site.replace("-priority", "") : n.site)
        .then((res) => {
          if (res.data.success) {
            setSiteName(res.data.data + (isPriority ? " Priority" : ""));
          }
        })
        .catch((e) => {});
      return () => {};
    }
  });

  return (
    <div className="card ">
      <div className="card-header" style={{ backgroundColor: "#0080001c" }}>
        <span
          type="button"
          data-toggle="collapse"
          // data-target={"#" + n._id}
          data-target={"#bitch" + i}
          // aria-controls="bitch"
          aria-expanded="true"
          aria-controls={`${n._id}`}
        >
          <div>
            {" "}
            Site: {siteName} ({n.results.length} NEW){" "}
          </div>
          <div> {Moment(n.createdAt).format("llll")}</div>
        </span>
      </div>
      <div
        className="collaspe show"
        // id={n._id}
        id={"bitch" + i}
        data-parent="#accordionExample"
      >
        <div className="card-body ">
          {n.results.map((r, j) => {
            return (
              <a
                href={r.url}
                target="_blank"
                style={{ color: "black", textDecoration: "none" }}
              >
                <div className="d-flex flex-row">
                  <div
                    style={{
                      width: 50,
                      height: 50,
                      backgroundImage: `url(${r.image})`,
                      backgroundSize: "contain",
                      backgroundRepeat: "no-repeat",
                      marginRight: 10,
                    }}
                  ></div>
                  <div className="d-flex flex-column">
                    <div> {r.name}</div>
                    <div style={{ fontSize: 11 }}>{r.price}</div>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
}
